export default "__VITE_ASSET__Do6Gh8W6__"